import { Form } from "react-bootstrap";
import { useWarehouses } from "../../api/warehouses.query";
import { useEffect } from "react";

interface WarehouseSelectorProps {
  value?: string;
  onChange: (warehouseId: string) => void;
  label?: string;
}

export const WarehouseSelector = ({ value, onChange, label = "Warehouse" }: WarehouseSelectorProps) => {
  const { data: warehouses, isLoading } = useWarehouses();

  useEffect(() => {
    if (!value && warehouses?.items?.length && warehouses.items[0]) {
      onChange(warehouses.items[0].id);
    }
  }, [value, warehouses?.items, onChange]);

  return (
    <Form.Select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={isLoading}
    >
      <option value="">Select a warehouse</option>
      {warehouses?.items?.map((warehouse) => (
        <option key={warehouse.id} value={warehouse.id}>
          {warehouse.name}
        </option>
      ))}
    </Form.Select>
  );
};